import PropTypes from "prop-types"
import UnifiedSearch from "modules/unified-search"
import EmptySearch from "components/compare-search/empty"
import { RECENT_INSTRUMENT_SEARCH_TYPES } from "resources/instruments"
import "./style.scss"

function CompareSearch({ account, modelId, itemsActions, close, disableSearchResult }) {
  return (
    <div className="comparison-settings-search">
      <UnifiedSearch
        disablePortal
        autoFocus
        account={account}
        modelId={modelId}
        itemsActions={itemsActions}
        onSelect={close}
        searchType={RECENT_INSTRUMENT_SEARCH_TYPES.COMPARISON}
        emptyContent={<EmptySearch />}
        disableResult={disableSearchResult}
        hiddenTypes={["researchTopics", "currencies"]}
      />
    </div>
  )
}

CompareSearch.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  itemsActions: PropTypes.object.isRequired,
  close: PropTypes.func,
  disableSearchResult: PropTypes.func.isRequired,
}

export default CompareSearch
